var _path, _path2, _path3, _g, _polygon, _path4, _polygon2, _path5, _circle, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _rect, _path15, _rect2, _path16, _path17, _path18, _path19, _rect3, _path20, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPatentSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 778.23467,
    height: 621,
    viewBox: "0 0 778.23467 621",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M349.19218,563.26056a9.12981,9.12981,0,1,0,15.79-9.17,9.827,9.827,0,0,0-.85987-1.22l7.68018-54.74.23-1.64,1.56006-11.17.23-1.61-.8501.04-14.87988.68-3.99024.18-.5,10.19-2.83007,57.29A9.1175,9.1175,0,0,0,349.19218,563.26056Z",
    transform: "translate(-210.88266 -139.5)",
    fill: "#ffb8b8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M371.98832,496.98877l-18.89453-1.7334a3.72978,3.72978,0,0,1-3.36426-4.03711l3.50464-39.292a14.32608,14.32608,0,1,1,28.44287,3.35742l-5.66553,38.54a3.72356,3.72356,0,0,1-3.67846,3.18066C372.219,497.00439,372.1038,496.99951,371.98832,496.98877Z",
    transform: "translate(-210.88266 -139.5)",
    fill: "#6c63ff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M357.66891,465.24332a26.316,26.316,0,0,1,9.67854-30.28775c7.125-4.875,16.875-6.625,27.375,5.875,21,25,26.5,52.5,26.5,52.5l-43,7S363.5976,482.45575,357.66891,465.24332Z",
    transform: "translate(-210.88266 -139.5)",
    fill: "#6c63ff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M384.73182,434.83057c-3.17613,8.75114-6.41934,17.85375-6.6295,27.62357a43.37837,43.37837,0,0,0,4.99971,21.46511c3.36949,6.10652,8.29052,10.57194,13.708,12.43883a5.69845,5.69845,0,0,0,3.22533.36379,3.59368,3.59368,0,0,0,2.50441-2.55479c.49036-1.72367-.09881-3.63614-.6782-5.3071-6.4283-18.53933-9.54439-34.64554-15.97269-53.18487Z",
    transform: "translate(-210.88266 -139.5)"
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "216.331 607.35 228.591 607.349 234.423 560.061 216.329 560.062 216.331 607.35",
    fill: "#ffb8b8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M424.587,743.34621h38.53073a0,0,0,0,1,0,0v14.88687a0,0,0,0,1,0,0H439.47387A14.88686,14.88686,0,0,1,424.587,743.34622v0A0,0,0,0,1,424.587,743.34621Z",
    transform: "translate(676.85635 1362.05903) rotate(179.99738)",
    fill: "#2f2e41"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "115.537 596.657 127.178 600.505 147.558 557.437 130.377 551.759 115.537 596.657",
    fill: "#ffb8b8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M321.71551,737.67709h38.53073a0,0,0,0,1,0,0V752.564a0,0,0,0,1,0,0H336.60237a14.88686,14.88686,0,0,1-14.88686-14.88686v0A0,0,0,0,1,321.71551,737.67709Z",
    transform: "translate(220.01155 1420.10696) rotate(-161.70982)",
    fill: "#2f2e41"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 173.7768,
    cy: 258.49592,
    r: 24.56103,
    fill: "#ffb8b8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M406.16435,733.68506l-11.3855-75.14453a3.49991,3.49991,0,0,0-6.86206-.29981L370.5789,729.853a4.5328,4.5328,0,0,1-5.08789,3.38476l-47.82495-7.68652a4.50023,4.50023,0,0,1-3.59253-5.75l62.36084-205.5957a3.50222,3.50222,0,0,0,.061-1.80176l-2.07641-8.99707a4.48349,4.48349,0,0,1,2.32666-5.01367c8.49169-4.333,29.99511-13.34082,46.2312-3.47364a4.55061,4.55061,0,0,1,2.07934,2.92676L473.77226,726.812a4.50014,4.50014,0,0,1-4,5.41895l-58.75708,5.26172q-.20325.01756-.40332.01757A4.50807,4.50807,0,0,1,406.16435,733.68506Z",
    transform: "translate(-210.88266 -139.5)",
    fill: "#2f2e41"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M445.0415,546.61746a9.07775,9.07775,0,0,0-5.64894-12.72182l-30.69314-62.72552L392.866,482.96082l35.034,57.7625a9.12691,9.12691,0,0,0,17.14157,5.89414Z",
    transform: "translate(-210.88266 -139.5)",
    fill: "#ffb8b8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M390.9412,486.87549,371.84184,452.3667a14.27979,14.27979,0,0,1-.1626-13.59766,13.67282,13.67282,0,0,1,3.74731-4.54492,14.33682,14.33682,0,0,1,14.51856-1.99121,14.7396,14.7396,0,0,1,7.4873,7.29883l16.74219,34.791a3.72283,3.72283,0,0,1-1.56152,4.877l-16.6211,9.13574a3.72689,3.72689,0,0,1-5.05078-1.46Z",
    transform: "translate(-210.88266 -139.5)",
    fill: "#6c63ff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M372.46442,376.55853a18.58061,18.58061,0,0,0,5.6148-3.13918,6.30248,6.30248,0,0,0,2.19428-5.77074c-.65568-2.93327-4.08847-4.53516-7.07593-4.205s-5.60549,2.07057-8.09116,3.76038c-2.18949,1.48846-4.44738,3.04774-5.812,5.3165s-1.573,5.46234.24176,7.39009c1.7809,1.89182,4.90275,1.92073,7.23437.77437s4.0572-3.20921,5.71037-5.21361Z",
    transform: "translate(-210.88266 -139.5)",
    fill: "#2f2e41"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M365.75047,368.009c1.28-6.80241-5.42873-13.27087-12.34789-13.46166s-13.2315,4.426-17.10571,10.162c-8.18556,12.11922-7.26968,28.08671-4.82667,42.50582s6.08452,29.299,2.34022,43.43613a43.92466,43.92466,0,0,1-32.534,31.01411c6.81464,4.9816,16.546,3.334,23.98-.6649,16.50958-8.881,26.31783-28.77749,23.30773-47.28092-1.48466-9.1264-5.6994-17.5483-8.525-26.35237s-4.16827-18.76479-.03568-27.03625,15.42788-13.31259,23.113-8.17116Z",
    transform: "translate(-210.88266 -139.5)",
    fill: "#2f2e41"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M384.07969,407.84185c-1.35681-3.97927-2.50284-9.07062,1.975-11.36715a8.06386,8.06386,0,0,1,6.24962-.33051c4.21075,1.42181,8.86949,2.61757,13.37731,1.92047a12.644,12.644,0,0,0,8.52585-4.95383c3.22514-4.66349,1.81879-11.44145-2.01882-15.61547a17.39824,17.39824,0,0,0-18.78241-4.26619c-5.30554-3.80011-12.63567-4.13176-18.68612-1.686s-10.87054,7.37825-14.11173,13.04254a30.20628,30.20628,0,0,0-4.29641,16.076,24.69216,24.69216,0,0,0,11.5472,19.651,8.89166,8.89166,0,0,0,8.86328.51785s3.91731-2.20137,5.6811-5.46929C383.75825,412.8513,384.80462,409.96794,384.07969,407.84185Z",
    transform: "translate(-210.88266 -139.5)",
    fill: "#2f2e41"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M592.88266,760.5h-381a1,1,0,0,1,0-2h381a1,1,0,0,1,0,2Z",
    transform: "translate(-210.88266 -139.5)",
    fill: "#3f3d56"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M821.06616,523.85693H699.92334a12.45287,12.45287,0,0,1-12.43872-12.43847V316.57129a12.45288,12.45288,0,0,1,12.43872-12.43848H821.06616ZM699.92334,306.13281a10.45043,10.45043,0,0,0-10.43872,10.43848V511.41846a10.45042,10.45042,0,0,0,10.43872,10.43847H819.06616V306.13281Z",
    transform: "translate(-210.88266 -139.5)",
    fill: "#3f3d56"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M817.93384,304.13281H939.07666a12.45288,12.45288,0,0,1,12.43872,12.43848V511.41846a12.45287,12.45287,0,0,1-12.43872,12.43847H817.93384Z",
    transform: "translate(-210.88266 -139.5)",
    fill: "#3f3d56"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 518.57142,
    y: 114.17349,
    width: 1.36735,
    height: 63.58163,
    fill: "#2f2e41"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M730.547,255.04081a14.35715,14.35715,0,1,1,14.35714-14.35714A14.35715,14.35715,0,0,1,730.547,255.04081Zm0-27.34694a12.9898,12.9898,0,1,0,12.98979,12.9898A12.9898,12.9898,0,0,0,730.547,227.69387Z",
    transform: "translate(-210.88266 -139.5)",
    fill: "#2f2e41"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 658.46937,
    y: 28.71431,
    width: 1.36735,
    height: 146.98979,
    fill: "#2f2e41"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M870.445,168.21428a14.35714,14.35714,0,1,1,14.35714-14.35714A14.35715,14.35715,0,0,1,870.445,168.21428Zm0-27.34693a12.9898,12.9898,0,1,0,12.98979,12.98979A12.9898,12.9898,0,0,0,870.445,140.86735Z",
    transform: "translate(-210.88266 -139.5)",
    fill: "#2f2e41"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M819.56633,460.55948a45.53906,45.53906,0,1,1,0-91.07812Z",
    transform: "translate(-210.88266 -139.5)",
    fill: "#6c63ff"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M819.56633,369.48136a45.53906,45.53906,0,1,1,0,91.07812Z",
    transform: "translate(-210.88266 -139.5)",
    fill: "#e6e6e6"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M977.49489,549.5H663.00511a11.63556,11.63556,0,0,1-11.62245-11.62245v-248.449a11.63556,11.63556,0,0,1,11.62245-11.62245H977.49489a11.63556,11.63556,0,0,1,11.62245,11.62245v248.449A11.63556,11.63556,0,0,1,977.49489,549.5ZM663.00511,279.17349a10.26674,10.26674,0,0,0-10.2551,10.2551v248.449a10.26674,10.26674,0,0,0,10.2551,10.2551H977.49489a10.26674,10.26674,0,0,0,10.2551-10.2551v-248.449a10.26674,10.26674,0,0,0-10.2551-10.2551Z",
    transform: "translate(-210.88266 -139.5)",
    fill: "#3f3d56"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 587.57142,
    y: 74,
    width: 1.36735,
    height: 174.75512,
    fill: "#2f2e41"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M799.547,214.04081a14.35715,14.35715,0,1,1,14.35714-14.35714A14.35715,14.35715,0,0,1,799.547,214.04081Zm0-27.34694a12.9898,12.9898,0,1,0,12.98979,12.9898A12.9898,12.9898,0,0,0,799.547,186.69387Z",
    transform: "translate(-210.88266 -139.5)",
    fill: "#2f2e41"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 499.5,
    cy: 364,
    r: 9,
    fill: "#3f3d56"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 720.5,
    cy: 364,
    r: 9,
    fill: "#e6e6e6"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 499.5,
    cy: 185,
    r: 9,
    fill: "#3f3d56"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 720.5,
    cy: 185,
    r: 9,
    fill: "#e6e6e6"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 515.56232,
    cy: 105.96941,
    r: 13.67347,
    fill: "#f2f2f2"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 655.46027,
    cy: 19.14288,
    r: 13.67347,
    fill: "#3f3d56"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 584.56232,
    cy: 64.96941,
    r: 13.67347,
    fill: "#6c63ff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatentSearch);
export default __webpack_public_path__ + "static/media/patent-search.db540bf8f6f4e1372fd7b208372d51af.svg";
export { ForwardRef as ReactComponent };